import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";
// Thunk for fetching all mattresses
// productsSlice.js

export const getAllMatress = createAsyncThunk(
  "products/getAllMatress", // action name consistent with slice
  async (
    {
      soft_type_id = "",
      metal_id = "",
      size_id = "",
      discount_min = "",
      discount_max = "",
      priceOrder = "",
      sortBy = "new_to_old",
      page = 1,
      per_page = 10,
    },
    { rejectWithValue },
  ) => {
    try {
      const query =
        `?soft_type_id=${soft_type_id}` +
        `&metal_id=${metal_id}` +
        `&size_id=${size_id}` +
        `&discount_min=${discount_min}` +
        `&discount_max=${discount_max}` +
        `&priceOrder=${priceOrder}` +
        `&sortBy=${sortBy}` +
        `&page=${page}` +
        `&per_page=${per_page}`;

      // console.log("Hitting API:",process.env.REACT_APP_BASE_URL + API.ALLMATTRESS + query);

      const response = await GET(API.ALLMATTRESS + query);
      console.log("Hitting API response:", response.data.data);
      return response?.data?.data; // this matches the backend response { data, current_page, total_pages, ... }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for getting home banners
export const getAllProducts = createAsyncThunk(
  "all-products",
  async (
    {
      category_id = "",
      subcategory_id = "",
      childcategory_id = "",
      size_id = "",
      mattress_id = "",
      height_id = "",
      brand_id = "",
      name = "",
      priceOrder = "",
      // type = "",
      need_id = "",
      sortBy = "",
      discount = "",
      shape_id = ""
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}&sortBy=${sortBy ||
            ""}&size_id=${size_id || ""}&height_id=${height_id ||
            ""}&mattress_id=${mattress_id || ""}&discount=${discount || ""}&shape_id=${shape_id || ""}`,
      );
      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsYouLike = createAsyncThunk(
  "all-products-you-like",
  async (
    {
      category_id = "",
      subcategory_id = "",
      childcategory_id = "",
      brand_id = "",
      name = "",
      priceOrder = "",
      type = "",
      need_id = "",
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `/${type}` +
          `?p_category_id=${category_id ||
            ""}&p_sub_category_id=${subcategory_id ||
            ""}&p_child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsMetarial = createAsyncThunk(
  "all-products-material",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder = "",
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `/${type}` +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      return Data?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllProductsShape = createAsyncThunk(
  "all-products-shape",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      shape_id, 
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_PRODUCTS +
          `/${type}` +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}&shape_id=${shape_id || ""}`
      );
      return Data?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllNewArrival = createAsyncThunk(
  "all-products-new-arrival",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_NEW_ARRIVALS +
          `/${type}` +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      return Data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllPopulerProduct = createAsyncThunk(
  "all-products-populer",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_POPULER_PRODUCTS +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      console.log(Data, "populer populer");

      return Data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllOfferedProduct = createAsyncThunk(
  "all-products-offered",
  async (
    {
      category_id,
      subcategory_id,
      childcategory_id,
      brand_id,
      name,
      priceOrder,
      type = "",
      need_id,
    },
    { rejectWithValue },
  ) => {
    try {
      const Data = await GET(
        API.GET_ALL_OFFERED_PRODUCTS +
          `?category_id=${category_id || ""}&sub_category_id=${subcategory_id ||
            ""}&child_category_id=${childcategory_id || ""}` +
          `&brand_id=${brand_id || ""}&need_id=${need_id || ""}&name=${name ||
            ""}&priceOrder=${priceOrder || ""}`,
      );
      console.log(Data, "offered offered");

      return Data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getProduct = createAsyncThunk(
  "product",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_PRODUCT + `/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getLinkedProduct = createAsyncThunk(
  "linked-product",
  async (id, { rejectWithValue }) => {
    try {
      const data = await GET(API.GET_LINKED_PRODUCT + `/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Thunk for gettingStore
export const getGroupByProduct = createAsyncThunk(
  "group-by-product",
  async ({ search = "", p_category_id }, { rejectWithValue }) => {
    try {
      const data = await GET(
        API.GET_ALL_PRODUCT_GROUP_BY_SUB_CATEGORIES +
          `?p_category_id=${p_category_id || ""}&product_name=${search}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const findCombination = createAsyncThunk(
  "auth/product-combination",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(
        API.GET_PRODUCT + `/combination`,
        data,
      );

      return combinationdata;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const pincodeCheck = createAsyncThunk(
  "auth/product-pincode",
  async (data, { rejectWithValue }) => {
    try {
      const combinationdata = await POST(
        API.GET_PRODUCT + `/${data?.product_id}`,
        data,
      );

      return combinationdata;
    } catch (error) {
      console.log("catch value");

      return rejectWithValue(error.message);
    }
  },
);

// Thunk for getting Add banners

// Thunk for getting Add banners
export const getspecialitystatus = createAsyncThunk(
  "product/add-specialstatus",
  async (_, { rejectWithValue }) => {
    try {
      const specialstatusData = await GET(API.GET_SPECIAL_STATUS);
      return specialstatusData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const PostSearchHistory = createAsyncThunk(
  "common/auth/user-photo-update",
  async (data, { rejectWithValue }) => {
    try {
      // console.log(data, "sss");
      const response = await POST(API.SEARCH_HISTORY, data);
      console.log(response?.success, "response");

      if (response?.success) {
        return response?.data;
      }

      return rejectWithValue(response);
    } catch (error) {
      console.log("in error");

      return rejectWithValue(error.message);
    }
  },
);
const handleAsyncState = (state, action, isSignin = false) => {
  switch (action.type) {
    case "pending":
      state.status = "loading";
      break;
    case "fulfilled":
      state.status = "succeeded";
      if (isSignin) {
        state.token = action.payload;
        state.is_signin = true;
      }
      break;
    case "rejected":
      state.status = "failed";
      state.error = action.payload;
      if (isSignin) state.is_signin = false;
      break;
    default:
      return state;
  }
};
// Create the slice
const productSlice = createSlice({
  name: "product",
  initialState: {
    // allProducts: [],
    allProducts: { data: [] }, //important
    allProducts_you_like: [],
    allProductsGroup: [],
    allProductsMetarial: [],
    allProductsShape: [],
    allProductsNewLaunch: [],
    allProductNewArrival: [],
    allPopulerProducts: [],
    allOfferedProducts: [],
    product: {},
    linked_products: [],
    addSpecialstatus: [],
    allMatress: [],
    matressStatus: "idle",
    matressError: null,
    error: null,
    status: "idle",
  },
  // reducers: {},
  reducers: {
  clearProducts: (state) => {
    state.allProducts = { data: [] };
  },
},
  extraReducers: (builder) => {
    builder

      .addCase(getAllMatress.pending, (state) => {
        state.matressStatus = "loading";
        state.matressError = null;
      })
      .addCase(getAllMatress.fulfilled, (state, action) => {
        state.matressStatus = "succeeded";
        state.allMatress = action.payload?.data || [];
        state.allMatress_current_page = action.payload?.current_page || 1;
        state.allMatress_total_pages = action.payload?.total_pages || 0;
        state.allMatress_per_page = action.payload?.per_page || 10;
        state.allMatress_total = action.payload?.total || 0;
      })
      .addCase(getAllMatress.rejected, (state, action) => {
        state.matressStatus = "failed";
        state.matressError = action.payload || "Something went wrong";
      })

      .addCase(getAllProducts.pending, (state) => {
        state.status = "loading";
        console.log("State after pending.....", state);
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.allProducts = action.payload || [];
        state.allProducts = action.payload || { data: [] }; //consistent shape
        console.log("State after fulfilled.........", state);
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected.....", state);
      })

      .addCase(getAllProductsYouLike.pending, (state) => {
        state.status = "loading";
        console.log("State after pending.....", state);
      })
      .addCase(getAllProductsYouLike.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allProducts_you_like = action.payload || [];
        console.log("State after fulfilled.........", state);
      })
      .addCase(getAllProductsYouLike.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected.....", state);
      })

      .addCase(getAllProductsMetarial.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllProductsMetarial.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.allProductsMetarial = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllProductsMetarial.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllProductsShape.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllProductsShape.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.allProductsShape = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllProductsShape.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })
      .addCase(getAllNewArrival.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllNewArrival.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.allProductNewArrival = action.payload || [];
      })
      .addCase(getAllNewArrival.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllPopulerProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllPopulerProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "Response payload in fulfilled case populer:",
          action.payload,
        );
        state.allPopulerProducts = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllPopulerProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getAllOfferedProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllOfferedProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "Response payload in fulfilled case populer:",
          action.payload,
        );
        state.allOfferedProducts = action.payload || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getAllOfferedProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log(
          "Response payload combination in fulfilled case:",
          action.payload,
        );
        state.product = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getLinkedProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getLinkedProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        state.linked_products = action.payload?.data || {};
        console.log("State after fulfilled", state);
      })
      .addCase(getLinkedProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(getGroupByProduct.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getGroupByProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allProductsGroup = action.payload || [];
        console.log("Response payload in fulfilled case:", action.payload);
        console.log("State after fulfilled", state);
      })
      .addCase(getGroupByProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(findCombination.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(findCombination.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(findCombination.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )
      .addCase(pincodeCheck.pending, (state) =>
        handleAsyncState(state, { type: "pending" }, true),
      )
      .addCase(pincodeCheck.fulfilled, (state, action) =>
        handleAsyncState(
          state,
          { type: "fulfilled", payload: action.payload },
          true,
        ),
      )
      .addCase(pincodeCheck.rejected, (state, action) =>
        handleAsyncState(
          state,
          { type: "rejected", payload: action.payload },
          true,
        ),
      )

      .addCase(getspecialitystatus.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getspecialitystatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.addSpecialstatus = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getspecialitystatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(PostSearchHistory.pending, (state) =>
        handleAsyncState(state, { type: "pending" }),
      )
      .addCase(PostSearchHistory.fulfilled, (state, action) =>
        handleAsyncState(state, { type: "fulfilled", payload: action.payload }),
      )
      .addCase(PostSearchHistory.rejected, (state, action) =>
        handleAsyncState(state, { type: "rejected", payload: action.payload }),
      );
  },
});

export default productSlice.reducer;
export const { clearProducts } = productSlice.actions;
